import { Notification } from '@dtpk-cc/components';
import { RouterTextLink } from 'components/content/RouterTextLink';

type CustomerSearchNotAvailableErrorProps = {
    skipPath: string;
};

export const CustomerSearchNotAvailableError = ({ skipPath }: CustomerSearchNotAvailableErrorProps) => (
    <Notification variant={Notification.Variant.alert} closable={false} noSideMargins noBottomMargin>
        <Notification.CopyText data-test-error="crmt_login_not_possible_error">
            Leider ist der Login aktuell nicht möglich. <br />
            Sie können Ihren Vertragsabschluss{' '}
            <RouterTextLink to={skipPath} data-test-action="manual_telekom_customer_booking">
                ohne Login fortsetzen.
            </RouterTextLink>
        </Notification.CopyText>
    </Notification>
);
